import { injectTranslate } from '@recruitee/i18n';
import { IconName } from '@recruitee/user-interface';

// eslint-disable-next-line max-lines-per-function
export const injectInfoFields = (): Array<{ icon: IconName; label: string }> => {
  const t = injectTranslate();
  return [
    {
      label: t('app.new_search_page.boolean_search_info.fields.candidate_name'),
      icon: 'person',
    },
    {
      label: t('app.new_search_page.boolean_search_info.fields.email'),
      icon: 'email',
    },
    {
      label: t('app.new_search_page.boolean_search_info.fields.phone'),
      icon: 'phone',
    },
    {
      label: t('app.new_search_page.boolean_search_info.fields.cv'),
      icon: 'file-document',
    },
    {
      label: t('app.new_search_page.boolean_search_info.fields.cv_text'),
      icon: 'file-account',
    },
    {
      label: t('app.new_search_page.boolean_search_info.fields.tags'),
      icon: 'tag',
    },
    {
      label: t('app.new_search_page.boolean_search_info.fields.sources'),
      icon: 'tag-text-outline',
    },
    {
      label: t('app.new_search_page.boolean_search_info.fields.offers'),
      icon: 'work',
    },
    {
      label: t('app.new_search_page.boolean_search_info.fields.stages'),
      icon: 'pipeline',
    },
  ];
};
